import script from "./StatisticsTabComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatisticsTabComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StatisticsTabComponent.vue?vue&type=style&index=0&id=76708fa6&lang=scss"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QDate,QItem,QItemSection,QTable,QTd,QField});
